import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isMobile } from 'react-device-detect';
import { useAppSelector } from '../../../redux/store';
import { BET_POT_TEXT_STROKE_COLOR_NUM } from '../../../styles/colors';
import { Rect } from '../pixiComponents/rect';
const HEIGHT_PX = isMobile ? 4 : 8;
const WIDTH_PADDING_PX = 15;
export const InactiveTimerBarContainer = ({ seatIndex, containerW }) => {
    const isWinningSeat = useAppSelector((state) => state.poker.winningSeatIndexes?.includes(seatIndex));
    const isPlayerIn = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.isIn);
    const inactiveTimerBarColorNum = useAppSelector((state) => state.theme.themeTable?.inactiveTimerBarColorNum);
    if (isWinningSeat) {
        return null;
    }
    const w = Math.max(10, containerW - 2 * WIDTH_PADDING_PX);
    const h = HEIGHT_PX;
    const x = -w / 2;
    const y = -HEIGHT_PX / 2;
    if (w < 80) {
        // don't bother showing the line, elements are close enough to be clearly associated with each other
        return null;
    }
    return (_jsx(Rect, { x: x, y: y, w: w, h: h, fillColor: isPlayerIn ? inactiveTimerBarColorNum : BET_POT_TEXT_STROKE_COLOR_NUM, radius: 12 }));
};
